
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cricket/teams",
      function () {
        return require("private-next-pages/cricket/teams/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cricket/teams"])
      });
    }
  